import { encodeQS } from "../../../lib/utils/QueryStringUtils.js";

type SupportedMethod = "GET" | "POST" | "PUT"




export abstract class GenericQSStatsCollector {



    constructor(public readonly name: string, 
                public readonly baseUrl: string) {

    }


    public collect(method: SupportedMethod, data?: {[k:string]: any}): Promise<void> {

        if(method == "POST" || method == "PUT") {
            const body = JSON.stringify(data);
            return fetch(this.baseUrl,{
                method: method,
                headers: {
                    "Content-Type": "application/json"
                },
                body: body
            }).then();
        }
        else {
            const qs = encodeQS(data,true);
            const url = this.baseUrl + "?" + qs;
            try {
                return new Promise((resolve,reject) => {
                    const img = new Image();
                    img.onload = () => resolve();
                    img.onerror = () => reject("error on stats marking")
                    img.src = url;
                })
                
            }
            catch(e) {
                return Promise.reject("error on stat marking " + e);
            }
        }
    }
}